





































import Vue from "vue";
//import { mapGetters } from "vuex";
import handleCanvas from "@/mixin/handleCanvas";

export default Vue.extend({
  mixins: [handleCanvas],
  props: {
    msg: String,
  },
});
